import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { masterDeleteData } from "../api";

export default function DeleteRecord({ row, onClose, tabeName, refresh }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation(req => masterDeleteData({ req }), {
    onSuccess: (data) => {
      if (data.status === "Error") {
        enqueueSnackbar(data.message || "Failed to Delete", {
          variant: "error",
        });
        return;
      }
      enqueueSnackbar("Record Deleted", {
        variant: "success",
      });
      queryClient.invalidateQueries(["getData", tabeName]);
      onClose();
      if (refresh) {
        refresh();
      }
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || "Failed to Delete", {
        variant: "error",
      });
    },
  });
  

  const handleDelete = () => {
    const req = {
      tableName: tabeName,
      idsArr: [row.id],
    };
    mutation.mutate(req);
  };
  return (
    <Dialog open>
      <DialogContent sx={{}}>
        <Typography variant="subtitle1" textAlign={"center"}>
          {row.name}
          <br />
          Are you Sure. You want to delete this record
        </Typography>
        <Stack direction={"row"} justifyContent={"center"} gap={2} mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleDelete();
            }}
          >
            Yes
          </Button>
          <Button variant="contained" color="error" onClick={onClose}>
            No
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
